<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'proxyList'}">
            代理列表
          </router-link>
        </li>
        <li class="active">添加/更新</li>
      </ol>
    </div>
    <div class="content-from">
      <el-row>
        <el-col>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>代理列表基本信息</span>
            </div>
            <div class="text item">
              <el-form ref="formName" :model="saveModel" label-width="120px" :rules="rules">
                <el-form-item label="代理名称:" prop="name">
                  <el-input v-model="saveModel.name" placeholder="代理名称"></el-input>
                </el-form-item>
                <el-form-item label="代理负责人:" prop="principal">
                  <el-input v-model="saveModel.principal" placeholder="负责人"></el-input>
                </el-form-item>
                <el-form-item label="代理联系方式:" prop="phoneNumber">
                  <el-input v-model="saveModel.phoneNumber" placeholder="联系方式"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div style=" text-align: center;">
            <el-button @click="$router.back(-1)">返回</el-button>
            <el-button type="primary" @click="saveGoods()">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      saveModel: {
        name: '',
        principal: '',
        phoneNumber: '',
      },
      outlets: [],
      rules: {
        name: [
          {required: true, message: '请输入代理名称', trigger: 'blur'},
        ],
        principal: [
          {required: true, message: '请输入联系人', trigger: 'blur'}
        ],
        phoneNumber: [
          {required: true, message: '请输入联系方式', trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {
    this.saveModel.id = this.$route.query.id;
    if (this.saveModel.id) {
      this.detailPrinter();
    }
  },
  created() {
    this.pageOutlets();
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    detailPrinter() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'proxy/detailProxy',
        data: {
          proxyId: _this.saveModel.id,
        },
        success: function (response) {
          _this.saveModel = response.item;
        }
      });
    },
    saveGoods() {
      var _this = this;
      _this.$refs['formName'].validate((valid) => {
        if (valid) {
          _this.$common.my_ajax({
            url: 'proxy/saveProxy',
            data: _this.saveModel,
            success: function (response) {
              _this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000,
                onClose: function () {
                  _this.$router.back(-1);
                }
              });
            }
          });
        } else {
          return false;
        }
      });
    },

  }
}
</script>

<style scoped>
.col-sm-3 {
  width: 20%;
}

.property-box {
  width: auto !important;
  max-width: 678px;
}

.can-shu {
  width: 160px;
  margin-bottom: 20px;
}

.steps {
  padding: 20px;
  margin: 20px;
}

.box-card {
  width: 75%;
  margin: 0 auto;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
